export const authUrl = 'https://open.weixin.qq.com/connect/oauth2'
export const appId = 'wx4d7bef52e010028e'
export const murl = 'http://doctorwxw-f.first-doctor.com/#'
export const qiniuUrl = 'https://qiniuimage.warmdoctor.cn/'
export const codeUrl = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket='

